import withInputErrorMessage from '../../withInputErrorMessage';
import withOptionsSelectValueInitById from '../withOptionsSelectValueInitById';
import withFormikSelect from '../withSelectFormik';

export const options = [
   {
      value: 'CPC',
      label: 'CPC',
      id: 0,
      name: 'CPC',
   },
   {
      value: 'CPA',
      label: 'CPA',
      id: 1,
      name: 'CPA',
   },
];

export default withFormikSelect(withInputErrorMessage(withOptionsSelectValueInitById(options)));
